import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from 'src/app/shared/models/chart.models';
import { CompanyOwned } from '../company/company-models.model';
import { InspectionMethodCodeStage } from './inspection-method-code-stage.model';

@HateoasResource('inspectionmethodcode')
export class InspectionMethodCode extends CompanyOwned {
  public invoer!: InspectionMethodCodeType;
  public naam!: string;
  public rekenmethode: InspectionMethodCodeMode | null | undefined;
  public stadia!: InspectionMethodCodeStage[];
  public verborgen!: boolean;

  //FRONTEND ONLY
  public used?: boolean;
}

export enum InspectionMethodCodeType {
  STAGE = 'stadium',
  PERCENTAGE = 'percentage',
  NUMBER = 'aantal',
}

export enum InspectionMethodCodeMode {
  EMPTY = 'geen',
  NEN2767 = 'NEN2767',
  RGD_BOEI = 'rgdBOEI',
}

export const inspectionMethodCodeInputs = (
  translateService: TranslateService,
  inputs: InspectionMethodCodeType[] = Object.values(InspectionMethodCodeType),
): SelectOption<InspectionMethodCodeType>[] =>
  inputs.map((input) => ({
    value: input,
    label: translateService.instant(`inspectionMethods.input.${input}`),
  }));

export const inspectionMethodCodeCalculationMethods = (
  translateService: TranslateService,
  calculationMethods: InspectionMethodCodeMode[] = Object.values(InspectionMethodCodeMode),
): SelectOption<InspectionMethodCodeMode>[] =>
  calculationMethods.map((calculationMethod) => ({
    value: calculationMethod,
    label: translateService.instant(`inspectionMethods.calculationMethod.${calculationMethod}`),
  }));
